import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { readableTypeName } from '@iotv/core-services';
import { AdjacentType, Assembler, edgeTypeMatrix } from '@iotv/datamodel-core';
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useContext } from 'react';
import { ActionIcons } from '../../../Iconography';
import { useMostProximateCustomer } from '../../../hooks/useMostProximateCustomer';
import { getViewDefinitionForNewObject } from '../../../v2/components/ExceptionTypesHandling/viewDefinitions';
import { standardCreateAndLinkItem } from '../../../v2/components/generic/ObjectTree/standardTransactionVariantFns';
import { ObjectDetailCard } from '../../../v2/components/generic/ObjectView/ObjectDetailCard';
import { DialogWrapper } from '../../common/DiaglogWrapper';
import { setDefaultValues } from '../../factories/AttributeDefinitions';
import { NavigationContext } from '../NavigationContext';
const { NODE_ENV, REACT_APP_DEPLOYMENT_STAGE: stage, REACT_APP_DEBUG } = process.env;
const isDevelopment = NODE_ENV === 'development' || stage === 'dev';
const debug = REACT_APP_DEBUG && false;
export const TopLevelMenu = ({ contextCustomer, roleArbitrationInstance, userFunctions, transactionFunctions }) => {
    const edgeTypeDefinition = edgeTypeMatrix.Customer.Group.customer_has_group;
    const { show, setShow, anchorEl, createGroupType, deviceType, domain, newObject, setNewObject } = useContext(NavigationContext);
    const mostProximateCustomer = useMostProximateCustomer({ item: contextCustomer });
    const postTransactionCallback = (res) => {
        if (res.err) {
            debug && console.log('TopLevelMenu received unsuccessful result from DetailCard', res.err.message);
        }
        if (res.data) {
            debug && console.log('TopLevelMenu received successful result from DetailCard', res.data);
            setNewObject(undefined);
            setShow(false);
        }
    };
    function handleItemClick() {
        const adjacentFilter = {
            adjacentType: AdjacentType.CHILD,
            edgeFilter: { edgeTypeId: edgeTypeDefinition.edgeTypeId },
            objectType: 'Group',
            otherObjectType: undefined,
        };
        const newObject = Assembler.getInstance({ type: adjacentFilter.objectType, supportedType: createGroupType, subSupportedType: deviceType, domain });
        if (!newObject)
            return debug && console.log('TopLevelMenu handleItemClick error assembling new object');
        else
            debug && console.log('TopLevelMenu handleItemClick has new object', newObject);
        debug && console.log('TopLevelMenu handleItemClick', adjacentFilter);
        const viewDefinition = getViewDefinitionForNewObject(newObject);
        if (!viewDefinition)
            return debug && console.log('TopLevelMenu handleItemClick error getting view definition for new object');
        else
            debug && console.log('TopLevelMenu handleItemClick has view definition', viewDefinition);
        setDefaultValues(newObject, viewDefinition);
        setNewObject(newObject);
        setShow(false);
    }
    const mutatedTransactionFunctions = {
        ...transactionFunctions,
        saveObject: (vob) => standardCreateAndLinkItem({
            contextObject: contextCustomer,
            vob,
            edgeTypeId: edgeTypeDefinition.edgeTypeId,
            postTransactionCallback,
        }),
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { children: _jsxs(Menu, { anchorEl: anchorEl, open: show, onClose: () => setShow(false), onClick: (e) => e.stopPropagation(), children: [isDevelopment && (_jsxs(_Fragment, { children: [_jsx(MenuItem, { id: "TopLevelMenu", disabled: true, children: _jsxs(ListItemText, { sx: { fontStyle: 'italic' }, children: ["TopLevelMenu ", contextCustomer?.name] }) }, "TopLevelMenu"), _jsx(Divider, {})] })), _jsxs(MenuItem, { id: edgeTypeDefinition.edgeTypeId, onClick: () => handleItemClick(), children: [_jsx(ListItemIcon, { children: _jsx(ActionIcons.Create, {}) }), _jsx(ListItemText, { children: `Add ${readableTypeName(createGroupType)}${isDevelopment ? ` (${edgeTypeDefinition.labels.out} — ${edgeTypeDefinition.edgeTypeId})` : ''}` })] }, edgeTypeDefinition.edgeTypeId)] }, "TopLevelMenu_menu") }, "TopLevelMenu_div"), _jsx(DialogWrapper, { header: `Add ${newObject?.type ? readableTypeName(newObject.type) : 'Entity'} to ${contextCustomer?.name}`,
                open: newObject !== undefined,
                setClosed: (actioned) => {
                    debug && console.log('TopLevelMenu: something returned from dialog tree', actioned);
                    setNewObject(undefined);
                },
                children: newObject ? (_jsx(ObjectDetailCard, { viewDefinition: getViewDefinitionForNewObject(newObject),
                    matchedPrimary: newObject,
                    contextObjectForDetailCard: contextCustomer,
                    mostProximateCustomer,
                    subContextCustomer: mostProximateCustomer,
                    userFunctions,
                    transactionFunctions: mutatedTransactionFunctions,
                    allowedActions: contextCustomer
                        ? roleArbitrationInstance.getObjectControlActionsByType({
                            sourceObjectType: contextCustomer.type,
                            targetObjectType: newObject.type,
                        })
                        : roleArbitrationInstance.getSingleObjectControlActions(newObject.type),
                    setClosed: (something) => {
                        debug && console.log('TopLevelMenu: something returned from dialog tree', something);
                        setNewObject(undefined);
                    } })) : (_jsx(_Fragment, {})) }, 'TopLevelMenu_dialogWrapper')] }));
};
